export default "__VITE_ASSET__D0PgzAJ9__"